(function() {
  const el = document.getElementById('horizontal-scrollable-list');
   if (!el) return;

  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let scrollLeft = 0;
  let draggingHorizontally = false;

  function onPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    startX = e.clientX;
    startY = e.clientY;
    scrollLeft = el.scrollLeft;
    isDragging = true;
    draggingHorizontally = false;
    el.classList.add('is-dragging');
    el.setPointerCapture(e.pointerId);
  }

  function onPointerMove(e) {
    if (!isDragging) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    // Don’t start horizontal drag until the horizontal movement is clearly greater
    if (!draggingHorizontally && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
      draggingHorizontally = true;
    }

    // Only handle drag if mostly horizontal
    if (draggingHorizontally) {
      el.scrollLeft = scrollLeft - dx;
      e.preventDefault(); // prevent page from vertically scrolling only during horizontal drag
    }
  }

  function endDrag(e) {
    isDragging = false;
    draggingHorizontally = false;
    el.classList.remove('is-dragging');
    try { el.releasePointerCapture(e.pointerId); } catch {}
  }

  el.addEventListener('pointerdown', onPointerDown);
  el.addEventListener('pointermove', onPointerMove, { passive: false });
  el.addEventListener('pointerup', endDrag);
  el.addEventListener('pointercancel', endDrag);
  el.addEventListener('pointerleave', endDrag);
})();